'use client'

import s from './Header.module.scss';
import {TopHeader} from "@/app/[locale]/common/components/Header/TopHeader/TopHeader";
import {MainHeader} from "@/app/[locale]/common/components/Header/MainHeader/MainHeader";
import {
    clearExpiredLocalStorage
} from "@/app/[locale]/common/utils/functions/clearExpiredLocalStorage/clearExpiredLocalStorage";
import {useEffect} from "react";

export const Header = () => {
    useEffect(() => {
        clearExpiredLocalStorage();
    }, []);

    return (
        <header className={s.header}>
            <TopHeader />
            <MainHeader />
        </header>
    );
};